import React, {Component} from 'react';
import Styles from './style.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import BoosterList from "../../pages/booster-list/component";

import PBfaviconAppleTouch from '../../assets/propertybooster-favicon/apple-touch-icon.png';
import PBfavicon16 from '../../assets/propertybooster-favicon/favicon-16x16.png';
import PBfavicon32 from '../../assets/propertybooster-favicon/favicon-32x32.png';
import PBfaviconSiteManifest from '../../assets/propertybooster-favicon/site.webmanifest';
import PBfaviconSiteSafari from '../../assets/propertybooster-favicon/safari-pinned-tab.svg';

import BBfaviconAppleTouch from '../../assets/boostabostad-favicon/apple-touch-icon.png';
import BBfavicon16 from '../../assets/boostabostad-favicon/favicon-16x16.png';
import BBfavicon32 from '../../assets/boostabostad-favicon/favicon-32x32.png';
import BBfaviconSiteManifest from '../../assets/boostabostad-favicon/site.webmanifest';
import BBfaviconSiteSafari from '../../assets/boostabostad-favicon/safari-pinned-tab.svg';

import YLfaviconAppleTouch from '../../assets/yieldlock-favicon/apple-touch-icon.png';
import YLfavicon16 from '../../assets/yieldlock-favicon/favicon-16x16.png';
import YLfavicon32 from '../../assets/yieldlock-favicon/favicon-32x32.png';
import YLfaviconSiteManifest from '../../assets/yieldlock-favicon/site.webmanifest';
import YLfaviconSiteSafari from '../../assets/yieldlock-favicon/safari-pinned-tab.svg';

import YSfaviconAppleTouch from '../../assets/yieldspotter-favicon/apple-touch-icon.png';
import YSfavicon16 from '../../assets/yieldspotter-favicon/favicon-16x16.png';
import YSfavicon32 from '../../assets/yieldspotter-favicon/favicon-32x32.png';
import YSfaviconSiteManifest from '../../assets/yieldspotter-favicon/site.webmanifest';
import YSfaviconSiteSafari from '../../assets/yieldspotter-favicon/safari-pinned-tab.svg';

import {Helmet} from "react-helmet";
import SellWithUs from "../../pages/sell-with-us/component";
import BuyWithUs from "../../pages/buy-with-us/component";
import queryString from "query-string";

class RouterWrapper extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: false,
            market: '',
            lang: ''
        }
    };

    componentWillMount() {
        this.functions.setApiDomain();
    }

    componentWillReceiveProps() {
        this.functions.setApiDomain();
    }

    update = {
        data: (response) => {
            try {
                for (let i = 0; i < response.languages.length; i++) {
                    if (this.state.lang.toLowerCase() === response.languages[i].toLowerCase()) {
                        langRegister.set(response.languages[i].toLowerCase());
                        break;
                    }
                }
            } catch (e) {
                langRegister.set(response.default_language.toLowerCase());
            }
            salesChannelRegister.set("name", this.renderSaleschannelName());

            if (response.country_region.country_code) {
                salesChannelRegister.set("market", response.country_region.country_code.toLocaleLowerCase());
            }
            if (response.name) {
                salesChannelRegister.set("company_name", response.name);
                this.update.title(response.name);
            }
            if (response.logo) {
                salesChannelRegister.set('logo', response.logo);
            }
            if (response.private) {
                salesChannelRegister.set('private', response.private);
            }
            if (response.logo_dashboard) {
                salesChannelRegister.set('logo_dashboard', response.logo_dashboard);
            }
            if (response.logo_mobile) {
                salesChannelRegister.set('logo_mobile', response.logo_mobile);
            }
            if (response.country_region) {
                salesChannelRegister.set('country_region', JSON.stringify(response.country_region));
            }
            if (response.default_language) {
                salesChannelRegister.set('default_language', response.default_language);
            }
            if (response.channels) {
                salesChannelRegister.set('channels', JSON.stringify(response.channels));
            }
            if (response.currency) {
                salesChannelRegister.set('currency', response.currency.toLowerCase());
            }
            if (response.from_email) {
                salesChannelRegister.set('email', response.from_email);
            }
            if (response.campaign_duration) {
                salesChannelRegister.set('durations', JSON.stringify(response.campaign_duration));
            }
            if (response.default_campaign_duration) {
                salesChannelRegister.set('default_duration', response.default_campaign_duration);
            }
            /*
            if (response.ga_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactGA.initialize(response.ga_id);
                salesChannelRegister.set('ga_id', response.ga_id);
            }
            if (response.ga4_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactGA4.initialize(response.ga4_id);
                salesChannelRegister.set('ga4_id', response.ga4_id);
            }
            /*/
            //TODO: add here TikTok and Snapchat portal pixels

            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                //GOOGLE ANALYTICS
                if (this.renderPropertyBooster()) {
                    ReactGA.initialize('UA-194332544-1');
                    salesChannelRegister.set('ga_id', 'UA-194332544-1');
                    ReactGA4.initialize('G-6C7PY37NV0');
                    salesChannelRegister.set('ga4_id', 'G-6C7PY37NV0');

                } else if (this.renderBoostaBostad()) {
                    ReactGA.initialize('UA-194386618-1');
                    salesChannelRegister.set('ga_id', 'UA-194386618-1');
                    ReactGA4.initialize('G-HEMHN9Z9LH');
                    salesChannelRegister.set('ga4_id', 'G-HEMHN9Z9LH');

                } else if (this.renderYieldlock()) {
                    ReactGA.initialize('UA-194380429-4');
                    salesChannelRegister.set('ga_id', 'UA-194380429-4');
                    ReactGA4.initialize('G-91JFBTXZKB');
                    salesChannelRegister.set('ga4_id', 'G-91JFBTXZKB');

                } else if (this.renderYieldspotter()) {
                    ReactGA.initialize('UA-194380429-1');
                    salesChannelRegister.set('ga_id', 'UA-194380429-1');
                    ReactGA4.initialize('G-0KP41MG5D6');
                    salesChannelRegister.set('ga4_id', 'G-0KP41MG5D6');
                }
            }
            /*
            if (response.fb_id && dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                ReactPixel.init(response.fb_id);
                salesChannelRegister.set('fb_id', response.fb_id);
            }
            /*/
           if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
               //FACEBOOK PIXEL
               if (this.renderPropertyBooster()) {
                   ReactPixel.init('1402963433409772');
                   salesChannelRegister.set('fb_id', '1402963433409772');
               } else if (this.renderBoostaBostad()) {
                   ReactPixel.init('1402217056813640');
                   salesChannelRegister.set('fb_id', '1402217056813640');
               } else if (this.renderYieldlock()) {
                   ReactPixel.init('1402963433409772');
                   salesChannelRegister.set('fb_id', '1402963433409772');
               } else if (this.renderYieldspotter()) {
                   ReactPixel.init('1402963433409772');
                   salesChannelRegister.set('fb_id', '1402963433409772');
               }
           }

            if (response.vat) {
                salesChannelRegister.set('vat', response.vat);
            } else {
                salesChannelRegister.set('vat', 0);
            }
            if (response.socialData) {
                if (response.socialData.image && response.socialData.title !== "") {
                    salesChannelRegister.set('socialIcon', response.socialData.image);
                }
                if (response.socialData.title && response.socialData.title !== "") {
                    salesChannelRegister.set('socialTitle', response.socialData.title);
                }
                if (response.socialData.facebookID && response.socialData.facebookID !== "") {
                    salesChannelRegister.set('facebookId', response.socialData.facebookID);
                }
                if (response.socialData.instagramID && response.socialData.instagramID !== "") {
                    salesChannelRegister.set('instagramId', response.socialData.instagramID);
                }
            }

            if (salesChannelRegister.get('market') === "se") {
                salesChannelRegister.set('languages', JSON.stringify([{
                    code: "sv",
                    name: "Svenska",
                    names: {sv: "Svenska", en: "Svenska"}
                }, {code: "en",
                    name: "English",
                    names: {sv: "English", en: "English"}}]));
            } else if (salesChannelRegister.get('market') === "ae") {
                salesChannelRegister.set('languages', JSON.stringify([{
                    code: "en",
                    name: "English",
                    names: {en: "English"}
                }]));
            }

            this.setState({error: false, isLoading: false});
        },
        title: (name) => {
            //document.title = name + " | " + this.renders.text("item_1");
        }
    };

    functions = {
        checkIfPrivate: () => {
            //this.setState({error: false, isLoading: false});
        },
        getHostingUrl: (url) => {
            var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
            if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
                return match[2];
            } else {
                return null;
            }
        },
        setDomain: (url) => {
            if(url.indexOf('localhost') !== -1){
                dataRegister.setDomain(this.functions.getHostingUrl('devpropertybooster.com'));
                this.functions.setVariables();
            }else{
                dataRegister.setDomain(this.functions.getHostingUrl(url));
                this.functions.setVariables();
            }
        },
        setApiDomain: () => {
            try {
                dataRegister.documentLocation().then((response) => {
                    let environment = response.headers.get('APP_PRODUCTION');
                    if (environment === "true") {
                        dataRegister.setApiDomain("primehit");
                        this.functions.setDomain(window.location.href);
                    } else if (environment === "local") {
                        dataRegister.setApiDomain(this.functions.getHostingUrl(window.location.href));
                        this.functions.setDomain(window.location.href);
                    } else {
                        dataRegister.setApiDomain("devprimehit");
                        this.functions.setDomain(window.location.href);
                    }
                }, (error) => {
                    dataRegister.setApiDomain("devprimehit");
                    this.functions.setDomain(window.location.href);
                });
            } catch (e) {}
        },
        setVariables: () => {
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            tokenRegister.remove();
            userRegister.remove();
            salesChannelRegister.remove('socialIcon');
            salesChannelRegister.remove('socialTitle');
            salesChannelRegister.remove('facebookId');
            salesChannelRegister.remove('instagramId');
            salesChannelRegister.remove('private');
            dataRegister.getSalesChannelData(this.props.match.params.market, this.renderSaleschannelName()).then((response) => {
                this.update.data(response);
            }, (error) => {
                this.setState({error: true, isLoading: false});
            });
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("router-wrapper", item);
        }
    };

    _renderText(item) {
        return langRegister.get("router-wrapper", item, this.props.match.params.lang);
    }

    renderBranding(){
        try {
            let query = queryString.parse(this.props.location.search);
            if(query.id && !(this.renderYieldlock() || this.renderYieldspotter())){
                return true;
            } else {
                return false;
            }
        } catch (e) {}
    }

    renderTitle() {

        let channel = "";
        let primary_text_pb = "Property Booster | ";
        let secondary_text_pb = "Property listings on steroids";
        let secondary_text_portal_pb = "Find home with us :)";
        let primary_text_bb = "Boosta Bostad | ";
        let secondary_text_bb = "Bostadsobjekt på steroider";
        let secondary_text_portal_bb = "Hitta hem med oss :)";
        if (this.props.match.params.lang === "en") {
            primary_text_bb = "Boosta Bostad | ";
            secondary_text_bb = "Property listings on steroids";
            secondary_text_portal_bb = "Find home with us :)";
        }

        try {
            if (window.location.hostname.indexOf("propertybooster") !== -1) {
                channel = "pb"
            } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                channel = "bb"
            }
            let query = queryString.parse(this.props.location.search);
            if (query.name) {
                return channel === "pb" ? primary_text_pb + "@" + query.name : primary_text_bb + "@" + query.name;
            } else {
                if (query.search === "true")  {
                    return channel === "pb" ? primary_text_pb + secondary_text_portal_pb : primary_text_bb + secondary_text_portal_bb;
                } else {
                    return channel === "pb" ? primary_text_pb + secondary_text_pb : primary_text_bb + secondary_text_bb;
                }
            }

        } catch (e) {return channel === "pb" ? primary_text_pb + secondary_text_pb : primary_text_bb + secondary_text_bb;}
    }

    renderLoader(){
        let query = queryString.parse(window.location.search);
        try {
            if (query.id) {
                return '#BFBFBF'
            } else {
                if(window.location.hostname.indexOf("propertybooster") !== -1){
                    return '#33B8CF'
                }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                    return '#7ECF5B'
                }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                    return '#00273A'
                }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                    return '#00273A'
                }else{
                    return '#ffffff'
                }
            }
        }catch (e) {
            return '#ffffff'
        }
    }

    renderSaleschannelName(){
        try {
            if(window.location.hostname.indexOf("propertybooster") !== -1){
                return 'propertybooster'
            }else if(window.location.hostname.indexOf("boostabostad") !== -1){
                return 'boostabostad'
            }else if(window.location.hostname.indexOf("yieldlock") !== -1){
                return 'yieldlock'
            }else if(window.location.hostname.indexOf("yieldspotter") !== -1){
                //Must fetch saleschannel yieldlock for Yieldspotter or landing pages will not be loaded
                //return 'yieldspotter'
                return 'yieldlock'
            }else{
                return 'propertybooster'
            }
        }catch (e) {
            return 'propertybooster'
        }
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad(){
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") === -1
        }catch (e) {
            return false
        }
    }

    renderYieldspotter(){
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        }catch (e) {
            return false
        }
    }

    render() {
        return (
            <div>
                {
                    window.location.hostname.indexOf("propertybooster") !== -1 &&
                    <Helmet>
                        <title>{this.renderTitle()}</title>
                        <meta name="description" content="We are on a mission to boost property listings with leading adtech, simply launch agency-grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={PBfaviconAppleTouch} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="32x32" href={PBfavicon32} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="16x16" href={PBfavicon16} data-react-helmet="true"/>
                        <link rel="manifest" href={PBfaviconSiteManifest} data-react-helmet="true"/>
                        <link rel="mask-icon" href={PBfaviconSiteSafari} color="#000000" data-react-helmet="true"/>
                        <meta name="msapplication-TileColor" content="#33b8cf" data-react-helmet="true"/>
                        <meta name="theme-color" content="#ffffff" data-react-helmet="true"/>

                        {/* --- NEW: CANONICAL --- */}
                        {/*
                        <link rel="canonical" href="https://propertybooster.io"/>
                        */}

                        {/* --- NEW: OG + TWITTER --- */}
                        {/*
                        <meta property="og:type" content="website"/>
                        <meta property="og:title" content={this.renderTitle()}/>
                        <meta property="og:description" content="We are on a mission to boost property listings with leading adtech, simply launch agency-grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                        <meta property="og:url" content="https://propertybooster.io"/>
                        <meta property="og:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776004593/propertybooster/media/PB_cover_social_share_1200x630_nologo_io_yvlkfv.png"/>

                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={this.renderTitle()}/>
                        <meta name="twitter:description" content="We are on a mission to boost property listings with leading adtech, simply launch agency-grade campaigns in minutes and enjoy close to zero admin – pay only for performance. Leverage AI driven multi-channel advertising across Google, Facebook, Instagram, Bing and many more"/>
                        <meta name="twitter:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776004593/propertybooster/media/PB_cover_social_share_1200x630_nologo_io_yvlkfv.png"/>
                         */}
                    </Helmet>
                }
                {
                    window.location.hostname.indexOf("boostabostad") !== -1 &&
                    <Helmet>
                        <title>{this.renderTitle()}</title>
                        <meta name="description" content="Vi är på kurs med att boosta bostadsobjekt med ledande adtech, skapa byråkampanjer på nolltid och slipp allt bök – betala bara för resultat. Få hävstång med AI-optimerad flerkanals-annonsering på Google, Facebook, Instagram, Bing och många fler"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={BBfaviconAppleTouch} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="32x32" href={BBfavicon32} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="16x16" href={BBfavicon16} data-react-helmet="true"/>
                        <link rel="manifest" href={BBfaviconSiteManifest} data-react-helmet="true"/>
                        <link rel="mask-icon" href={BBfaviconSiteSafari} color="#000000" data-react-helmet="true"/>
                        <meta name="msapplication-TileColor" content="#7ecf5b" data-react-helmet="true"/>
                        <meta name="theme-color" content="#ffffff" data-react-helmet="true"/>

                        {/* --- NEW: CANONICAL --- */}
                        {/*
                        <link rel="canonical" href="https://boostabostad.se"/>
                        */}

                        {/* --- NEW: OG + TWITTER --- */}
                        {/*
                        <meta property="og:type" content="website"/>
                        <meta property="og:title" content={this.renderTitle()}/>
                        <meta property="og:description" content="Vi är på kurs med att boosta bostadsobjekt med ledande adtech, skapa byråkampanjer på nolltid och slipp allt bök – betala bara för resultat. Få hävstång med AI-optimerad flerkanals-annonsering på Google, Facebook, Instagram, Bing och många fler"/>
                        <meta property="og:url" content="https://boostabostad.se"/>
                        <meta property="og:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776006293/boostabostad/media/BB_cover_social_share_1200x630_nologo_ogfenm.png"/>

                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={this.renderTitle()}/>
                        <meta name="twitter:description" content="Vi är på kurs med att boosta bostadsobjekt med ledande adtech, skapa byråkampanjer på nolltid och slipp allt bök – betala bara för resultat. Få hävstång med AI-optimerad flerkanals-annonsering på Google, Facebook, Instagram, Bing och många fler"/>
                        <meta name="twitter:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776006293/boostabostad/media/BB_cover_social_share_1200x630_nologo_ogfenm.png"/>
                        */}
                    </Helmet>
                }
                {
                    window.location.hostname.indexOf("yieldlock") !== -1 &&
                    <Helmet>
                        <title>YIELDLOCK | Yieldlock any property</title>
                        <meta name="description" content="Yieldlock any on-plan property and boost attraction and resale value with the world's leading retail leaseback framework powered by ROISEC. Leverage powerful lead generation and produce intent for millions of investors worldwide without any administration or prior skills"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={YLfaviconAppleTouch} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="32x32" href={YLfavicon32} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="16x16" href={YLfavicon16} data-react-helmet="true"/>
                        <link rel="manifest" href={YLfaviconSiteManifest} data-react-helmet="true"/>
                        <link rel="mask-icon" href={YLfaviconSiteSafari} color="#000000" data-react-helmet="true"/>
                        <meta name="msapplication-TileColor" content="#e65032" data-react-helmet="true"/>
                        <meta name="theme-color" content="#ffffff" data-react-helmet="true"/>

                        {/* --- NEW: OG + TWITTER --- */}
                        {/*
                        <meta property="og:type" content="website"/>
                        <meta property="og:title" content="YIELDLOCK | Yieldlock any property"/>
                        <meta property="og:description" content="Yieldlock any on-plan property and boost attraction and resale value with the world's leading retail leaseback framework powered by ROISEC. Leverage powerful lead generation and produce intent for millions of investors worldwide without any administration or prior skills"/>
                        <meta property="og:url" content="https://yieldlock.com"/>
                        <meta property="og:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776007312/yieldlock/media/YL_cover_social_share_1200x630_nologo_vamvki.png"/>

                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content="YIELDLOCK | Yieldlock any property"/>
                        <meta name="twitter:description" content="Yieldlock any on-plan property and boost attraction and resale value with the world's leading retail leaseback framework powered by ROISEC. Leverage powerful lead generation and produce intent for millions of investors worldwide without any administration or prior skills"/>
                        <meta name="twitter:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776007312/yieldlock/media/YL_cover_social_share_1200x630_nologo_vamvki.png"/>
                        */}
                    </Helmet>
                }
                {
                    window.location.hostname.indexOf("yieldspotter") !== -1 &&
                    <Helmet>
                        <title>YIELDSPOTTER | Home of the real yield</title>
                        <meta name="description" content="Yieldspotter is the smarter way to enter and exit the Dubai property market"/>
                        <link rel="apple-touch-icon" sizes="180x180" href={YSfaviconAppleTouch} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="32x32" href={YSfavicon32} data-react-helmet="true"/>
                        <link rel="icon" type="image/png" sizes="16x16" href={YSfavicon16} data-react-helmet="true"/>
                        <link rel="manifest" href={YSfaviconSiteManifest} data-react-helmet="true"/>
                        <link rel="mask-icon" href={YSfaviconSiteSafari} color="#000000" data-react-helmet="true"/>
                        <meta name="msapplication-TileColor" content="#e65032" data-react-helmet="true"/>
                        <meta name="theme-color" content="#ffffff" data-react-helmet="true"/>

                        {/* --- NEW: CANONICAL --- */}
                        {/*
                        <link rel="canonical" href="https://yieldspotter.com"/>
                        */}

                        {/* --- NEW: OG + TWITTER --- */}
                        {/*
                        <meta property="og:type" content="website"/>
                        <meta property="og:title" content="YIELDSPOTTER | Home of the real yield"/>
                        <meta property="og:description" content="Yieldspotter is the smarter way to enter and exit the Dubai property market"/>
                        <meta property="og:url" content="https://yieldspotter.com"/>
                        <meta property="og:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776007324/yieldspotter/media/YS_cover_social_share_1200x630_nologo_gbobfo.png"/>

                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content="YIELDSPOTTER | Home of the real yield"/>
                        <meta name="twitter:description" content="Yieldspotter is the smarter way to enter and exit the Dubai property market"/>
                        <meta name="twitter:image" content="https://res.cloudinary.com/propertybooster/image/upload/v1776007324/yieldspotter/media/YS_cover_social_share_1200x630_nologo_gbobfo.png"/>
                         */}
                    </Helmet>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <Switch>
                        <Route exact path={"/:market/:lang"} component={BoosterList}/>
                        <Route exact path={"/:market/:lang/sell-with-us"} component={SellWithUs}/>
                        <Route exact path={"/:market/:lang/buy-with-us"} component={BuyWithUs}/>
                    </Switch>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <div className={Styles.error}>
                            {this._renderText("item_2")}
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={this.renderLoader()} loading={true}/>
                    </div>
                }
            </div>
        );
    }

}

export default RouterWrapper


// WEBPACK FOOTER //
// ./src/components/router-wrapper/component.js